import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { MapEventsService } from 'src/app/core/services/map-events.service'
import { MapService } from 'src/app/core/services/map.service'
import { WarningTypes } from '../enums/warning-types.enum'
import { Datasources } from '../enums/datasources.enum'
import { AuthService } from 'src/app/core/services/auth.service'
import { LayerObservationsService } from '../layers/layer-observations.service'
import { DataObservationsService } from '../services/data-observations.service'
import { DataRoadCoverageService } from '../services/data-road-coverage.service'
import { Layers } from '../layers-config/layers'
import { ObservationSources } from '../enums/observation-categories.enum'
import { LayerClusteredSignsService } from '../layers/layer-clustered-signs.service'
import { DataClusteredSignsService } from '../services/data-clustered-signs.service'
import { LayerMatchedSignsService } from '../layers/layer-matched-sign.service'
import { DataMatchedSignsService } from '../services/data-matched-signs.service'
import { LayerBlacklistAreaService } from '../layers/layer-blacklist-area.service'
import { DataBlacklistAreaService } from '../services/data-blacklist-area.service'
import { DataConstructionSitesService } from '../services/data-construction-sites.service'
import { LayerConstructionSitesService } from '../layers/layer-construction-site.service'
import { LayerRoadCoverageService } from '../layers/layer-road-coverage.service'
import { LayerSpeedProfileService } from '../layers/layer-speed-profile.service'
import { DataSpeedProfileService } from '../services/data-speed-profile.service'

export const constructionSitesLayerProvider = {
  provide: 'constructionSitesLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    authService: AuthService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerConstructionSitesService => {
    return new LayerConstructionSitesService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.ConstructionSites.name,
      8,
      8,
      8,
      new DataConstructionSitesService(http, appState, config),
    )
  },
  deps: [
    Router,
    MapService,
    MapEventsService,
    AppStateService,
    AuthService,
    HttpClient,
    APP_CONFIG,
  ],
}

export const roadCoverageLayerProvider = {
  provide: 'roadCoverageLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    authService: AuthService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerRoadCoverageService => {
    return new LayerRoadCoverageService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.RoadCoverage.name,
      8,
      8,
      8,
      new DataRoadCoverageService(http, appState, config),
    )
  },
  deps: [
    Router,
    MapService,
    MapEventsService,
    AppStateService,
    AuthService,
    HttpClient,
    APP_CONFIG,
  ],
}

export const provider1ObservationsLayerProvider = {
  provide: 'provider1ObservationsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerObservationsService => {
    return new LayerObservationsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider1Observations.name,
      16,
      16,
      14,
      new DataObservationsService(http, appState, config, ObservationSources.Provider1),
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const provider2ObservationsLayerProvider = {
  provide: 'provider2ObservationsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerObservationsService => {
    return new LayerObservationsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.Provider2Observations.name,
      16,
      16,
      14,
      new DataObservationsService(http, appState, config, ObservationSources.Provider2),
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const clusteredSignsLayerProvider = {
  provide: 'clusteredSignsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerClusteredSignsService => {
    return new LayerClusteredSignsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.ClusteredSigns.name,
      16,
      16,
      14,
      new DataClusteredSignsService(http, appState, config),
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const matchedSignsLayerProvider = {
  provide: 'matchedSignsLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerMatchedSignsService => {
    return new LayerMatchedSignsService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.MatchedSigns.name,
      9,
      9,
      9,
      new DataMatchedSignsService(http, appState, config),
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, HttpClient, APP_CONFIG],
}

export const blacklistAreaLayerProvider = {
  provide: 'blacklistAreaLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    blacklistAreaService: DataBlacklistAreaService,
  ): LayerBlacklistAreaService => {
    return new LayerBlacklistAreaService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.BlacklistAreas.name,
      blacklistAreaService,
    )
  },
  deps: [Router, MapService, MapEventsService, AppStateService, DataBlacklistAreaService],
}

export const speedProfileLayerProvider = {
  provide: 'speedProfileLayer',
  useFactory: (
    router: Router,
    mapService: MapService,
    mapEventsService: MapEventsService,
    appState: AppStateService,
    authService: AuthService,
    http: HttpClient,
    config: AppConfigModel,
  ): LayerSpeedProfileService => {
    return new LayerSpeedProfileService(
      router,
      mapService,
      mapEventsService,
      appState,
      Layers.SpeedProfile.name,
      8,
      8,
      8,
      new DataSpeedProfileService(http, appState, config),
    )
  },
  deps: [
    Router,
    MapService,
    MapEventsService,
    AppStateService,
    AuthService,
    HttpClient,
    APP_CONFIG,
  ],
}
